import { createContext, useContext, useState } from "react";

const JourneyContext = createContext(null);

export const JourneyProvider = ({ children }) => {
  const [journey, setJourneyState] = useState(() => localStorage.getItem("fba_journey") || null);

  const setJourney = (j) => {
    setJourneyState(j);
    if (j) localStorage.setItem("fba_journey", j);
  };

  const resetJourney = () => {
    setJourneyState(null);
    localStorage.removeItem("fba_journey");
  };

  return (
    <JourneyContext.Provider value={{ journey, setJourney, resetJourney }}>
      {children}
    </JourneyContext.Provider>
  );
};

export const useJourney = () => useContext(JourneyContext);
